
export function Section({ children, placeItems="start", className }) {
  return (
    <div className="max-w-2xl m-auto w-full">
      <div className={"px-4 md:px-0 m-auto text-" + placeItems + " " + className}>
        {children}
      </div>
    </div>
  );
}